import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { serialize } from "object-to-formdata";
import {
  getData,
  getOne,
  createOne,
  updateOne,
  deleteOne,
} from "../../services/api";

export const getAllUsers = createAsyncThunk(
  "users/getUsers",
  async (filter, { getState, rejectWithValue }) => {
    try {
      const { data } = await getData("users", filter);
      return data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// create user
export const createUser = createAsyncThunk(
  "user/createusr",
  async (user, { rejectWithValue, thunkAPI }) => {
    try {
      const { data } = await createOne(
        "users",
        serialize(user, { indices: true })
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// create user
export const updateUser = createAsyncThunk(
  "user/updateusr",
  async (data, { rejectWithValue, thunkAPI }) => {
    const { id, ...user } = data;
    try {
      const { data } = await updateOne(
        "users",
        id,
        serialize(user, { indices: true })
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUser = createAsyncThunk(
  "user/getUser",
  async (id, { getState, rejectWithValue }) => {
    try {
      const { data } = await getOne("users", id);
      return data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/delete",
  async (id, { getState, rejectWithValue }) => {
    try {
      const { data } = await deleteOne("users", id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
const initialState = {
  users: [],
  user: {},
  isSuccess: false,
  error: null,
  loading: "",
  meta: {},
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: {
    //get users
    [getAllUsers.pending]: (state, { payload }) => {
      state.loading = "loading";
    },
    [getAllUsers.fulfilled]: (state, { payload }) => {
      state.loading = "success";
      state.users = payload.payload.users;
      state.isSuccess = true;
      state.meta = payload.meta;
    },
    [getAllUsers.rejected]: (state, { payload }) => {
      state.error = payload;
      state.loading = "failed";
      state.isSuccess = false;
    },
    //get user
    [getUser.pending]: (state, { payload }) => {
      state.loading = "loading";
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.loading = "success";
      state.user = payload.payload.user;
      state.isSuccess = true;
    },
    [getUser.rejected]: (state, { payload }) => {
      state.error = payload;
      state.loading = "failed";
      state.isSuccess = false;
    },
    // delete user
    [deleteUser.fulfilled]: (state, { payload }) => {
      state.loading = "success";
      const users = state.users.filter((el) => el._id !== payload);
      state.users = users;
    },
    [deleteUser.rejected]: (state, { payload }) => {
      state.error = payload;
      state.loading = "failed";
    },
  },
});

export const { log } = usersSlice.actions;
export default usersSlice.reducer;
